import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Typography, useTheme } from "@material-ui/core";
import React from "react";
import { PreflightReportInfo } from "api/creatives";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ReadOnlyField } from "components/SchemaProvider";
import { capitalize } from "utils";

interface ValidationInfoProps {
    header: JSX.Element;
    defaultExpanded?: boolean;
    simplified?: boolean;
    label?: string;
    info: PreflightReportInfo[];
}

const ValidationInfoDetails = ({ info }: { info: PreflightReportInfo[] }) => {
    return (
        <Box pb={2} overflow="hidden" flexWrap="wrap" width="100%" display="flex">
            {info.map(({ key, unit, value, expectedValue }, index) => {
                if (expectedValue) {
                    return (
                        <React.Fragment key={index}>
                            <Box flexDirection="column" flex={0.5} flexBasis="50%" display="flex">
                                <ReadOnlyField caption={capitalize(key)} label={`${value}${unit}`} />
                            </Box>
                            <Box flexDirection="column" flex={0.5} flexBasis="50%" display="flex">
                                <ReadOnlyField
                                    // TODO: Add translation
                                    caption={`Expected ${key}`}
                                    label={`${expectedValue}${unit}`}
                                />
                            </Box>
                        </React.Fragment>
                    );
                }

                return (
                    <Box key={index} flexDirection="column" flex={0.5} flexBasis="50%" display="flex">
                        <ReadOnlyField caption={capitalize(key)} label={value} />
                    </Box>
                );
            })}
        </Box>
    );
};

const ValidationInfoContainer = ({ header, info, label }: ValidationInfoProps) => {
    return (
        <>
            <Box pb={1} display="flex" alignItems="center">
                {header}
                {label && (
                    <Typography component="div" variant="body2" color="textSecondary">
                        <Box fontWeight="fontWeightBold">{label}</Box>
                    </Typography>
                )}
            </Box>
            <Divider />
            <ValidationInfoDetails info={info} />
        </>
    );
};

export const ValidationInfo = ({ header, info, label, defaultExpanded = false, simplified }: ValidationInfoProps) => {
    const theme = useTheme();

    if (simplified) {
        return <ValidationInfoContainer info={info} label={label} header={header} />;
    }

    return (
        <Accordion
            defaultExpanded={defaultExpanded}
            variant="outlined"
            style={{ backgroundColor: theme.palette.grey["100"], border: "none" }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box display="flex" alignItems="center">
                    {header}
                    {label && (
                        <Typography component="div" variant="body2" color="textSecondary">
                            <Box fontWeight="fontWeightBold">{label}</Box>
                        </Typography>
                    )}
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <ValidationInfoDetails info={info} />
            </AccordionDetails>
        </Accordion>
    );
};
